module.exports = __webpack_public_path__ + "img/electronic_reserved_selected.309848aa.svg";